import React, { useState, useCallback } from 'react';
import connect from 'Shared/connect';
import FeedbackButton from 'Shared/Button/Feedback';
import Modal from 'Shared/Modal';
import { translate } from 'Shared/translate';
import { addRecipeShort, createNewListAndAdd, getMenus } from '../RecipeMenus/action-creators';
import DropDownMenu, { DropDownItem } from 'Shared/DropDownMenu';
import Dialog, { DialogType } from 'Shared/Dialog';
import { Input } from 'Shared/Fields';
const CreateMenu = (props) => {
    let textInput = React.createRef();
    const [isOpen, setOpen] = useState(false);
    const [menus, setMenus] = useState([]);
    const handleClose = useCallback(() => setOpen(false), []);
    const handleConfirm = useCallback(() => {
        if (textInput.current.element.value.length > 0) {
            return props.createNewListAndAdd(textInput.current.element.value, props.id);
        }
        return Promise.reject();
    }, [textInput, props.id]);
    const setupModal = () => {
        return props.getAllMenus().then(result => {
            setMenus(result.menus);
            setOpen(true);
        });
    };
    return (React.createElement("div", { onClick: e => e.stopPropagation(), className: props.className },
        React.createElement(FeedbackButton, { appearance: "secondary", onClickWithFeedback: (e, activate) => activate(setupModal()) }, translate('/RecipeMenu/AddToMenu')),
        React.createElement(Modal, { title: translate('/RecipeMenu/AddRecipe'), isOpen: isOpen, onClose: handleClose, reserveSpaceForCloseButton: true, fadeDesign: true },
            React.createElement("h4", null, translate('/RecipeMenu/AddToExisistingMenu')),
            React.createElement(DropDownMenu, { title: translate('/Shared/Choose') }, menus.map(list => (React.createElement(DropDownItem, { key: list.id, value: list.id, text: list.displayName, onClick: () => props.addRecipeShort(list.id, props.id), onClose: handleClose })))),
            React.createElement("h4", null, translate('/RecipeMenu/CreateNewMenu')),
            React.createElement(Input, { ref: textInput, width: "100%", autoFocus: true }),
            React.createElement(Dialog, { type: DialogType.OkCancel, onConfirm: handleConfirm, onCancel: handleClose, onStatusWasFulfilled: handleClose }))));
};
export default connect((state) => ({}), (dispatch) => ({
    addRecipeShort: (listId, id) => dispatch(addRecipeShort(listId, id)),
    createNewListAndAdd: (displayName, id) => dispatch(createNewListAndAdd(displayName, id)),
    getAllMenus: () => dispatch(getMenus()),
}))(CreateMenu);
